import React from 'react'
import { useDispatch } from 'react-redux'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { PageIcon } from 'components/layout/search/Search'
import selectSearchMenu from 'redux/selectors/selectSearchMenu'
import useMenu from 'hooks/useMenu'
import { setCurrentSearchType } from 'redux/actions'

const SearchMenu = ({ anchorEl, setAnchorEl }) => {
  const dispatch = useDispatch()
  const handleMenuOnClose = () => setAnchorEl(null)
  const handleMenuItemOnClick = (name) => e => dispatch(setCurrentSearchType(name))

  const menuItems = useMenu(selectSearchMenu)

  return (
    <Menu
      classes={{ list: 'flex flex-column' }}
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleMenuOnClose}
      data-testid='search-types-popup'
    >
      {menuItems && menuItems.map(({ title, target }) => (
        <MenuItem key={target} onClick={handleMenuItemOnClick(target)} classes={{ gutters: 'ph6 pv3' }}>
          <ListItemIcon classes={{ root: 'black' }}>
            <PageIcon className='w7' {...{ searchTypeName: target, searchTypes: menuItems }} />
          </ListItemIcon>
          <ListItemText primary={title} />
        </MenuItem>
      ))}
    </Menu>
  )
}

export default SearchMenu
